// extracted by mini-css-extract-plugin
export default {"container":"XJ-z","error":"YJ-z","disabled":"ZJ-z","submit":"_J-z","option":"aK-z","success":"bK-z","failure":"cK-z"};